export type Ratings = 0 | 1 | 2 | 3 | 4 | 5;
export const MAX_RATING = 5;
